module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DutdnX/Images/MSRCover.jpg?1739571356672",
      "alt": "This image is the cover for the book Family in His Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Family in His Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Who Wasn't Trying To Fix Up  Dr. Zack Hemingway?")]), _c('br'), _c('br'), _vm._v("Even his boss had handpicked two of his three daughters as perfect candidates for the position of Zack's wife. But it was the other daughter who'd caught Zack's no-longer roving eye."), _c('br'), _c('br'), _vm._v("A sweet Christian woman who worked with children in need, Chloe Kilgannon possessed everything he wanted in a wife. Except a willingness to say I do. Why? What was Chloe hidingor hiding from? Zack had to find out before he lost Chloe for good. For when his own family dropped a life-changing bombshell on him, he knew that some secrets were truly meant to be shared. "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gail Gaymer Martin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning novelist, Gail Gaymer Martin authored over 80 novels with 4 million books in print, receiving a Carol and 2 RT Reviewer Choice Awards. Her novel THE CHRISTMAS KITE was optioned for a Hallmark movie. Gail authored Writers Digest's WRITING THE CHRISTIAN ROMANCE and is a co-founder of American Christian Fiction Writers. CBS local news named her as the four best novelists in Detroit. Before publication, Gail worked as a counselor and a university instructor.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0